import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";

interface RequireAuthProps {
  allowedRoles?: string[];
  requiredPermission?: string;
}

const RequireAuth: React.FC<RequireAuthProps> = ({
  allowedRoles = [],
  requiredPermission,
}) => {
  const { user, isAuthenticated, isLoading, hasPermission } = useAuth();

  const location = useLocation();

  if (isLoading || !isAuthenticated || !user) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
      </div>
    );
  }

  // if (!isAuthenticated || !user) {
  //   return <Navigate to="/sign-in" state={{ from: location }} replace />;
  // }

  // Check role-based access
  if (allowedRoles.length > 0) {
    const roles = Array.isArray(user?.roles)
      ? user?.roles
      : typeof user?.roles === "string"
        ? user.roles.split(",")
        : [];

    const hasRequiredRole =
      roles?.some((userRole) =>
        allowedRoles.some(
          (role) => role.toLowerCase() === userRole.toLowerCase(),
        ),
      ) ||
      (allowedRoles.includes("admin") && user?.isAdmin);

    if (!hasRequiredRole) {
      return <Navigate to="/sign-in" state={{ from: location }} replace />;
    }
  }

  // Check permission-based access
  if (requiredPermission && !hasPermission(requiredPermission)) {
    return <Navigate to="/unauthorized" state={{ from: location }} replace />;
  }

  return <Outlet />;
};

export default RequireAuth;
